import { z } from "zod";
import { ORDER_STATUSES, smbOrderStatusSchema } from "./smb";
import { smbAdminOrderSchema, smbStepKeySchema } from "./smb-admin";

const page = z.coerce.number().int().min(1).max(10000).catch(1);
export const smbBoardQuerySchema = z.object({
  status: z.string().max(80).optional(), package: z.string().max(160).optional(),
  brand: z.string().max(160).optional(), test: z.string().max(10).optional(),
  q: z.string().trim().max(160).optional(),
  view: z.enum(["board", "table"]).catch("board").default("board"),
  sort: z.enum(["age", "cost"]).catch("age").default("age"),
  direction: z.enum(["asc", "desc"]).catch("desc").default("desc"),
  pages: z.string().max(1500).optional(),
  locatorPage: page.default(1),
}).strip();
export type SmbBoardQuery = z.infer<typeof smbBoardQuerySchema>;
export function parseStagePages(value?: string): Record<string, number> {
  let raw: unknown;
  try { raw = JSON.parse(value ?? "{}"); } catch { raw = {}; }
  const parsed = z.record(page).safeParse(raw);
  return Object.fromEntries(ORDER_STATUSES.map(status => [status, parsed.success ? parsed.data[status] ?? 1 : 1]));
}
export const smbBoardCardSchema = smbAdminOrderSchema.extend({
  brandName: z.string().nullable(), logoUrl: z.string().nullable(), brandUrl: z.string().nullable(),
  packageName: z.string().nullable(), ageMinutes: z.number().nonnegative(), stuck: z.boolean(),
  costUsd: z.number().finite().nonnegative().nullable(),
  nextAction: z.object({ label: z.string(), step: smbStepKeySchema, href: z.string(), available: z.boolean() }),
});
export type SmbBoardCard = z.infer<typeof smbBoardCardSchema>;
export const smbLocatorItemSchema = z.object({
  brandId: z.string().nullable(), brandName: z.string().nullable(), brandUrl: z.string().nullable(),
  order: smbBoardCardSchema.nullable(),
});
export const smbBoardResponseSchema = z.object({
  stages: z.array(z.object({
    status: smbOrderStatusSchema, count: z.number().int(), page: z.number().int(),
    orders: z.array(smbBoardCardSchema).max(25),
  })),
  locator: z.object({ items: z.array(smbLocatorItemSchema).max(25), total: z.number(), page: z.number() }),
  generatedAt: z.string(), pageSize: z.literal(25),
});
export type SmbBoardResponse = z.infer<typeof smbBoardResponseSchema>;
